import React from 'react'
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import LocationOnIcon from 'material-ui-icons/LocationOn';
import CachedIcon from 'material-ui-icons/Cached';
import {connect} from 'react-redux'
import filterActions from '../Redux/filterRedux'

const mapDispatchToProps = dispatch => ({
  selectLabels: text => dispatch(filterActions.selectLabels(text))
})
const GileadeDrawerItem = ({color, text, value, selectLabels, noIcon}) => (
  <ListItem button onClick={() => selectLabels(value)}>
      <ListItemIcon style={{color, marginRight: 0}}>
        {noIcon ? <CachedIcon /> : <LocationOnIcon /> }
      </ListItemIcon>
    <ListItemText primary={text}/>
  </ListItem>
)

export default connect(null, mapDispatchToProps)(GileadeDrawerItem)



// WEBPACK FOOTER //
// ./src/Components/GileadeDrawerItem.js